/* eslint-disable react/jsx-curly-newline */
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { defaultValues } from 'features/ProjectProposal/defaultValues';
import { Tooltip } from 'primereact/tooltip';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { formatFileNameProduct } from 'utils/func';

import { PRODUCT_TYPE } from 'constant/summary-report.constant';
import HardProductDialog from '../HardProductDialog';

export default function HardProductTable({
  disabled,
  control,
  projectCode,
  handleDownloadFile,
  setProductFilesDelete,
  hardProducts,
}) {
  // #region Data
  const { t } = useTranslation();
  const hardProductRef = useRef();

  const { fields, insert, remove, update } = useFieldArray({
    control,
    name: 'researchResult.hardProducts',
    keyName: 'customId',
  });
  // #endregion Data
  return (
    <>
      <h4>{t('projectProposal.researchResult.productAndResearchResultDes.hardProduct.label')}</h4>
      {hardProducts?.length > 0 && (
        <div className="form-table my-2">
          <table className="mb-2">
            <thead>
              <tr>
                <th rowSpan={3} className="text-center" style={{ minWidth: 50, width: 50 }}>
                  {t('formLayout.numericalOrder')}
                </th>
                <th rowSpan={3} className="text-center" style={{ minWidth: 220, width: 220 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.productName'
                  )}
                </th>
                <th rowSpan={3} className="text-center" style={{ minWidth: 200, width: 200 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityCriteria'
                  )}
                </th>
                <th rowSpan={3} className="text-center" style={{ minWidth: 80, width: 80 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.measure'
                  )}
                </th>
                <th colSpan={3} className="text-center" style={{ minWidth: 330, width: '100%' }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityLevel'
                  )}
                </th>
                <th rowSpan={3} className="text-center" style={{ minWidth: 100, width: 100 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.expectedQuantity'
                  )}
                </th>
              </tr>
              <tr>
                <th rowSpan={2} style={{ minWidth: 80, width: 80 }}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.evaluativeCriteria'
                  )}
                </th>
                <th colSpan={2}>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.similarModel'
                  )}
                </th>
              </tr>
              <tr>
                <th>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.domestic'
                  )}
                </th>
                <th>
                  {t(
                    'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.international'
                  )}
                </th>
              </tr>
            </thead>
            <tbody>
              {hardProducts?.map((item, index) => (
                <tr key={item.id}>
                  <td className="text-center">{index + 1}</td>
                  <td>{item?.name}</td>
                  <td>{item?.qualityCriteria}</td>
                  <td>{item?.measure}</td>
                  <td>{item?.evaluativeCriteria}</td>
                  <td>{item?.domesticModelQuality}</td>
                  <td>{item?.internationalModelQuality}</td>
                  <td>{item?.expectedQuantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p>({t('projectProposal.researchResult.productAndResearchResultDes.hardProduct.note')})</p>

      <div className="form-table">
        <table className="mb-2">
          <thead>
            <tr>
              <th rowSpan={3} className="text-center" style={{ minWidth: 50, width: 50 }}>
                {t('formLayout.numericalOrder')}
              </th>
              <th rowSpan={3} className="text-center" style={{ minWidth: 220, width: 220 }}>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.productName'
                )}
              </th>
              <th rowSpan={3} className="text-center" style={{ minWidth: 200, width: 200 }}>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityCriteria'
                )}
              </th>
              <th rowSpan={3} className="text-center" style={{ minWidth: 80, width: 80 }}>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.measure'
                )}
              </th>
              <th colSpan={3} className="text-center" style={{ minWidth: 330, width: '100%' }}>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.qualityLevel'
                )}
              </th>
              <th rowSpan={3} className="text-center" style={{ minWidth: 100, width: 100 }}>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.expectedQuantity'
                )}
              </th>
              <th rowSpan={3} className="text-center" style={{ minWidth: 100, width: 100 }}>
                {t('r05.b.b2.table.proof')}
              </th>
              {!disabled && (
                <th rowSpan={3} className="float text-center" style={{ minWidth: 80, width: 80 }}>
                  {t('projectProposal.action')}
                </th>
              )}
            </tr>
            <tr>
              <th rowSpan={2} style={{ minWidth: 80, width: 80 }}>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.evaluativeCriteria'
                )}
              </th>
              <th colSpan={2}>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.similarModel'
                )}
              </th>
            </tr>
            <tr>
              <th>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.domestic'
                )}
              </th>
              <th>
                {t(
                  'projectProposal.researchResult.productAndResearchResultDes.hardProduct.fields.international'
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {fields?.map((item, index) => (
              <tr key={item.id}>
                <td className="text-center">{index + 1}</td>
                <td>{item?.productDetail?.name}</td>
                <td>{item?.productDetail?.qualityCriteria}</td>
                <td>{item?.productDetail?.measure}</td>
                <td>{item?.productDetail?.evaluativeCriteria}</td>
                <td>{item?.productDetail?.domesticModelQuality}</td>
                <td>{item?.productDetail?.internationalModelQuality}</td>
                <td>{item?.productDetail?.expectedQuantity}</td>

                <td>
                  {!item?.file?.name ? (
                    item?.fileUrl && (
                      <span
                        className="p-button p-button-text p-button-sm mt-1 p-0"
                        onClick={() =>
                          handleDownloadFile(
                            item?.fileUrl,
                            formatFileNameProduct(
                              item?.fileUrl || '',
                              projectCode,
                              PRODUCT_TYPE.HARD_PRODUCT.short,
                              index + 1
                            )
                          )
                        }
                      >
                        <i className="pi pi-file-pdf text-red-500 text-xl" />{' '}
                        <span className="text-blue-500 underline font-italic ml-1">
                          {formatFileNameProduct(
                            item?.fileUrl || '',
                            projectCode,
                            PRODUCT_TYPE.HARD_PRODUCT.short,
                            index + 1
                          )}
                        </span>
                      </span>
                    )
                  ) : (
                    <span>
                      {formatFileNameProduct(
                        item?.file?.name || '',
                        projectCode,
                        PRODUCT_TYPE.HARD_PRODUCT.short,
                        index + 1
                      )}
                    </span>
                  )}
                </td>
                {!disabled && (
                  <td className="float text-center p-0">
                    <div className="">
                      <i
                        onClick={() => {
                          hardProductRef.current.open({
                            index,
                            projectCode,
                            value: fields[index],
                            update,
                            type: 'UPDATE',
                          });
                        }}
                        className="edit-icon pi pi-pencil text-primary cursor-pointer mt-1"
                        data-pr-tooltip={t('formLayout.action.edit')}
                        data-pr-position="left"
                      />
                      <Tooltip target=".edit-icon" />
                    </div>

                    <i
                      onClick={() => {
                        if (item?.id) {
                          setProductFilesDelete((prev) => [...prev, item.id]);
                        }
                        remove(index);
                      }}
                      className="remove-icon pi pi-times text-red-700 cursor-pointer mb-1"
                      data-pr-tooltip={t('formLayout.action.remove')}
                      data-pr-position="left"
                    />
                    <Tooltip target=".remove-icon" />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!disabled && (
        <div className="flex justify-content-center mt-2">
          <i
            onClick={() => {
              hardProductRef.current.open({
                index: fields?.length ?? 0,
                value: defaultValues.hardProduct,
                projectCode,
                insert,
                type: 'INSERT',
              });
            }}
            className="add-hard-product pi pi-plus text-primary cursor-pointer bg-primary p-1 border-circle"
            data-pr-tooltip={t('formLayout.action.add')}
            data-pr-position="left"
          />
          <Tooltip target=".add-hard-product" />
        </div>
      )}

      <HardProductDialog
        productTypeShort={PRODUCT_TYPE.HARD_PRODUCT.short}
        ref={hardProductRef}
        handleDownloadFile={handleDownloadFile}
      />
    </>
  );
}

HardProductTable.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  projectCode: PropTypes.string.isRequired,
  handleDownloadFile: PropTypes.func,
  setProductFilesDelete: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  hardProducts: PropTypes.array,
};

HardProductTable.defaultProps = {
  disabled: false,
  handleDownloadFile: () => null,
  setProductFilesDelete: () => null,
  hardProducts: [],
};
